/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, BigNumberish, Contract, ContractFactory, Overrides } from "ethers"
import { Provider, TransactionRequest } from "@ethersproject/providers"
import type { MultiSigWallet, MultiSigWalletInterface } from "../MultiSigWallet"

const _abi = [
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_owners",
        type: "address[]",
      },
      {
        internalType: "uint256",
        name: "_required",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "transactionId",
        type: "uint256",
      },
    ],
    name: "Confirmation",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Deposit",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "transactionId",
        type: "uint256",
      },
    ],
    name: "Execution",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "transactionId",
        type: "uint256",
      },
    ],
    name: "ExecutionFailure",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "OwnerAddition",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "OwnerRemoval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "required",
        type: "uint256",
      },
    ],
    name: "RequirementChange",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "transactionId",
        type: "uint256",
      },
    ],
    name: "Revocation",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "transactionId",
        type: "uint256",
      },
    ],
    name: "Submission",
    type: "event",
  },
  {
    inputs: [],
    name: "MAX_OWNER_COUNT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "addOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_required",
        type: "uint256",
      },
    ],
    name: "changeRequirement",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "transactionId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "signer",
        type: "address",
      },
    ],
    name: "confirmTransaction",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "transactionId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "sig",
        type: "bytes",
      },
      {
        internalType: "address",
        name: "signer",
        type: "address",
      },
    ],
    name: "confirmTransactionByRelay",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "confirmations",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "transactionId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "sig",
        type: "bytes",
      },
      {
        internalType: "address",
        name: "signer",
        type: "address",
      },
    ],
    name: "executeTransactionByRelay",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "transactionId",
        type: "uint256",
      },
    ],
    name: "getConfirmationCount",
    outputs: [
      {
        internalType: "uint256",
        name: "count",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "transactionId",
        type: "uint256",
      },
    ],
    name: "getConfirmations",
    outputs: [
      {
        internalType: "address[]",
        name: "_confirmations",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getOwners",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "pending",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "executed",
        type: "bool",
      },
    ],
    name: "getTransactionCount",
    outputs: [
      {
        internalType: "uint256",
        name: "count",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "from",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "to",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "pending",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "executed",
        type: "bool",
      },
    ],
    name: "getTransactionIds",
    outputs: [
      {
        internalType: "uint256[]",
        name: "_transactionIds",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "transactionId",
        type: "uint256",
      },
    ],
    name: "isConfirmed",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "isOwner",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "nonces",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "owners",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "transactionId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "nonce",
        type: "uint256",
      },
    ],
    name: "prepareConfirmTransaction",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "transactionId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "nonce",
        type: "uint256",
      },
    ],
    name: "prepareExecuteTransaction",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "transactionId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "nonce",
        type: "uint256",
      },
    ],
    name: "prepareRevokeConfirmation",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "destination",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
      {
        internalType: "uint256",
        name: "nonce",
        type: "uint256",
      },
    ],
    name: "prepareSubmitTransaction",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "removeOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "replaceOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "required",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "transactionId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "sig",
        type: "bytes",
      },
      {
        internalType: "address",
        name: "signer",
        type: "address",
      },
    ],
    name: "revokeConfirmationByRelay",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "destination",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
      {
        internalType: "bytes",
        name: "sig",
        type: "bytes",
      },
      {
        internalType: "address",
        name: "signer",
        type: "address",
      },
    ],
    name: "submitTransactionByRelay",
    outputs: [
      {
        internalType: "uint256",
        name: "transactionId",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "transactionCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "transactions",
    outputs: [
      {
        internalType: "address",
        name: "destination",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
      {
        internalType: "bool",
        name: "executed",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
]

const _bytecode =
  "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"

export class MultiSigWallet__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer)
  }

  deploy(
    _owners: string[],
    _required: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> },
  ): Promise<MultiSigWallet> {
    return super.deploy(_owners, _required, overrides || {}) as Promise<MultiSigWallet>
  }
  getDeployTransaction(
    _owners: string[],
    _required: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> },
  ): TransactionRequest {
    return super.getDeployTransaction(_owners, _required, overrides || {})
  }
  attach(address: string): MultiSigWallet {
    return super.attach(address) as MultiSigWallet
  }
  connect(signer: Signer): MultiSigWallet__factory {
    return super.connect(signer) as MultiSigWallet__factory
  }
  static readonly bytecode = _bytecode
  static readonly abi = _abi
  static createInterface(): MultiSigWalletInterface {
    return new utils.Interface(_abi) as MultiSigWalletInterface
  }
  static connect(address: string, signerOrProvider: Signer | Provider): MultiSigWallet {
    return new Contract(address, _abi, signerOrProvider) as MultiSigWallet
  }
}
